var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationpin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    "aria-label": "Location pin icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7c3aec",
    d: "M256 0C139.2 0 44.3 94.9 44.3 211.7c0 56.6 22 109.8 62.1 149.8L256 512l149.6-150.5c40-40 62.1-93.2 62.1-149.8C467.7 94.9 372.8 0 256 0zm0 278.3c-36.7 0-66.6-29.9-66.6-66.6s29.9-66.6 66.6-66.6 66.6 29.9 66.6 66.6-29.9 66.6-66.6 66.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationpin);
export default __webpack_public_path__ + "static/media/locationpin.1fec84bc2f3cffcc3c1ec8ab9dc3603c.svg";
export { ForwardRef as ReactComponent };